import React from "react";
import { Link } from "react-router-dom";
import { isEmpty } from "../../../core/utils/helpers";

const Logo = ({ logo = "/logo.png", to, width }) => {
  return isEmpty(to) ? (
    <img
      src={process.env.PUBLIC_URL + logo}
      alt="Maarifa University"
      style={{ width: width }}
    />
  ) : (
    <Link to={to}>
      <img
        src={process.env.PUBLIC_URL + logo}
        alt="Maarifa University"
        style={{ width: width }}
      />
    </Link>
  );
};

export default Logo;
